<ng-template #alertModal let-modal>
    <div class="modal-header border-0 bg-secondary-content"></div>
  
    <div class="modal-body text-center bg-secondary-content" style="margin-top: -30px">
      <fa-icon
        class="border-secondary"
        size="2x"
        [icon]="icon.faWarning"
        [styles]="{ color: '#dc3545' }"
      >
      </fa-icon>
      <p class="mb-2 text-white romper-error">{{message}}</p>
      <button (click)="reloadPage()" appButton variant="secondary">{{'Reintentar' | translate}}</button>
      <br />
    </div>
</ng-template>
  